
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(\-webpack_sharing_consume_default_react_react\-_(36dc|cdde)|webpack_sharing_consume_default_react_jsx\-dev\-runtime_react_jsx\-dev\-runtime\-webpack_sharing_c\-5690e6)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
